import { TrailerSensorData } from '@asset-solutions/customer-portal/orders/models';
import { downloadCSV } from '@asset-solutions/shared/utilities';

export const downloadTempData = (tempPayload: TrailerSensorData[], trailerId: string): void => {
  const headers = [
    'Trailer #',
    'Date & Time',
    'Position',
    'Speed',
    'SP1',
    'Unit Mode',
    'Op Mode',
    'S1',
    'S2',
    'S3',
    'S4',
    'Door 1',
    'Door 2',
    'Door 3',
    'Return Air',
    'Discharge Air',
    'Fuel Level',
    'Battery Voltage',
    'Engine Hours',
    'Total Hours'
  ];
  const data = tempPayload.map((dataPoint) => {
    return [
      trailerId,
      dataPoint.posTime,
      dataPoint.positionName,
      dataPoint.speed,
      dataPoint.setPoint,
      dataPoint.unitMode,
      dataPoint.opMode,
      dataPoint.sensor1,
      dataPoint.sensor2,
      dataPoint.sensor3,
      dataPoint.sensor4,
      dataPoint.zone1DoorOpen !== undefined ? (dataPoint.zone1DoorOpen ? 'Open' : 'Closed') : '',
      dataPoint.zone2DoorOpen !== undefined ? (dataPoint.zone2DoorOpen ? 'Open' : 'Closed') : '',
      dataPoint.zone3DoorOpen !== undefined ? (dataPoint.zone3DoorOpen ? 'Open' : 'Closed') : '',
      dataPoint.returnAir,
      dataPoint.dischargeAir,
      dataPoint.fuelLevel,
      dataPoint.batteryVoltage,
      dataPoint.engineHours,
      dataPoint.totalHours
    ];
  });
  downloadCSV(data, 'sensor-data.csv', headers);
};
